import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { mediaQuery, OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    icon: {
      width: "14px",
      height: "14px",
      flexShrink: 0,
    },
    paperContainer: {
      padding: 0,
    },
    link: {
      alignItems: "center",
      display: "inline-flex",
      flexShrink: 0,
      gap: theme.spacing(2),
      maxWidth: "100%",
      "& > span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
    tabContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      flexGrow: 1,
      padding: theme.spacing(8.5, 6, 4, 6),
      gap: theme.spacing(7),
      boxShadow: `0px 0px 0px 1px ${theme.gray100}`,
      "&.MuiTab-root.Mui-selected": {
        backgroundColor: theme.white00,
      },
      "&:first-child": {
        borderTopLeftRadius: theme.spacing(4),
      },
      "&:last-child": {
        borderTopRightRadius: theme.spacing(4),
      },
    },
    tabContent: {
      alignItems: "flex-start",
      color: theme.black,
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(6),
    },
    tabName: {
      fontSize: 14,
      textTransform: "none",
      color: "#727272",
      ".MuiTab-root.Mui-selected &": {
        color: theme.black,
      },
    },
    tabValue: {
      fontSize: 24,
      fontWeight: 400,
    },
    indicator: {
      backgroundColor: theme.gray50,
      borderBottom: `1px solid ${theme.gray100}`,
      position: "relative",
      "& .MuiTabs-indicator": {
        top: 0,
        height: "3px",
      },
    },
    scrollButton: {
      "& > .MuiTabs-scrollButtons ~.MuiTabs-scrollButtons": {
        left: "auto",
        right: 0,
      },
      "& .MuiTabs-scrollButtons": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        opacity: 1,
        position: "absolute",
        height: "100%",
        width: "86px",
        zIndex: 1,
        "&.Mui-disabled": { opacity: 0 },
        "&:first-child": {
          background: `linear-gradient(120.11deg, ${theme.gray100} 18.4%, rgba(255, 255, 255, 0) 69.38%)`,
        },
        "&:last-child": {
          background: `linear-gradient(233.11deg, ${theme.gray100} 18.4%, rgba(255, 255, 255, 0) 69.38%)`,
        },
      },
      "& > .MuiTabs-scrollButtons": {
        left: 0,
      },
      "& .MuiSvgIcon-root": {
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        fill: theme.white50,
        backgroundColor: theme.primary500,
      },
    },
    bottomSection: {
      alignItems: "center",
      borderTop: `1px solid ${theme.gray100}`,
      color: theme.gray400,
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(6),
      minHeight: theme.spacing(27),
      padding: theme.spacing(8, 12),
    },
    menu: {
      alignItems: "center",
      cursor: "pointer",
      display: "flex",
      marginLeft: "initial",
    },
    tooltipIcon: {
      width: "16px !important",
      height: "16px !important",
      color: `${theme.gray500} !important`,
    },
    tooltipLinks: {
      display: "flex",
      gap: theme.spacing(4),
      marginTop: theme.spacing(6),
      width: "100%",
      flexWrap: "wrap",
    },
    dateDropdownSelector: {
      textTransform: "none",
      color: theme.gray400,
      fontSize: "14px",
      fontWeight: 400,
      padding: 0,
      [`@media (max-width: ${mediaQuery.desktop}px)`]: {
        display: "none",
      },
    },
    highlighted: {
      color: theme.black,
      marginLeft: theme.spacing(2),
    },
    header: {
      display: "inline-block",
      fontSize: 18,
      paddingBottom: theme.spacing(5),
    },
    dateRangeMenuIcon: {
      width: "24px",
      height: "24px",
    },
    elemWrapper: {
      display: "flex",
      alignItems: "center",
    },
    tooltipText: {
      whiteSpace: "break-spaces",
      marginTop: theme.spacing(2),
      fontSize: "12px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    tooltipTitle: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.gray800,
    },
  }),
);
